import styled from 'styled-components';

import * as mx from 'core/styles/mixins';

export const Wrapper = styled.div``;

export const Section = styled.section`
	padding: 24px;

	& + & {
		border-top: 1px solid ${({ theme }) => theme.global.borders.module};
	}
`;

export const TitleContainer = styled.div<{
	isEdit?: boolean;
}>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: ${props => (props.isEdit ? `15px` : '25px')};
`;

export const Dl = styled.dl`
	margin: 0;

	div + div {
		margin-top: 16px;
	}

	dt {
		${mx.bp('s')`
			padding-right: 50px;
		`}
	}

	dt,
	dd {
		margin: 0;

		${mx.bp('s')`
			display: inline-block;
			width: 50%;
		`}
	}
`;

export const DlEdit = styled.dl`
	margin: 0;
	> div {
		display: flex;
		justify-content: space-between;
		align-items: center;

		> div:first-child {
			width: 100%;
		}
	}

	dt {
		${mx.bp('s')`
			padding-right: 50px;
		`}

		> p {
			color: ${({ theme }) =>
				theme.global.typography.colors.default} !important;
		}
	}

	dt,
	dd {
		margin: 0;

		${mx.bp('s')`
			display: inline-block;
			width: 50%;
		`}
	}
`;

export const CtaContainerEdit = styled.div`
	width: 62px;
`;
